import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Chip from "@mui/material/Chip";

import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import ComplianceCertificates from "../CommonComponents/ComplianceCertificates/CompalianceCertificates";
import {
	EditCompanyDetailsModalTypes,
	complianceCertColumns,
	contactPersonColumns,
	factoryAddressDetailColumns,
	factoryBasicDetailColumns,
	factoryUrlParamName,
	fileTableColumns,
	supplierDrawerElements,
	supplierUrlParamName,
} from "data/supplierPageData";
import DisplayInfo from "../CommonComponents/DisplayInfo/DisplayInfo";
import EditAddressDetails from "./EditAddressDetails/EditAddressDetails";
import DisplayAddressInfo from "../DisplayAddressInfo/DisplayAddressInfo";
import EditContactPersons from "../CommonComponents/EditContactPersons/EditContactPersons";
import DisplayTable from "../CommonComponents/DisplayTable/DisplayTable";
import AddFiles from "../CommonComponents/AddFiles/AddFiles";
import axios from "axios";
import EditFactoryDetails from "./EditFactoryDetails/EditFactoryDetails";
import { useLocation, useSearchParams } from "react-router-dom";
import { Breadcrumbs, Link as MuiLink } from "@mui/material";
import StatusButtons from "components/SupplierPage/reusableComp/statusButton";
import { getSupplierFileSignedUrl } from "../CompanyDetails/data";
import { parse } from "date-fns";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import { getLatestApproval } from "utils/supplierApprovalHelpers";
import { SupplierPageHeader, SupplierSection, supplierUi } from "../../shared/supplierUi";

const SYNC_SECTION_LABELS = {
	basic_details: "Basic Details",
	address_details: "Address Details",
	files: "Files",
	compliance_certificates: "Compliance Certificates",
	contact_details: "Contact Details",
};

const FactoryDetails = ({
	foreignKey,
	companyData,
	pageData,
	setPageData,
	setTab,
	disableEdit,
	hidePageHeader = false,
	handleReject,
	updateSupplierStore,
	handleUnapprove,
	handleEditFApprovalDb,
}) => {
	const { setSnackBar, snackBar, setSnackBarOpen, loginUser, setLoadingOpen } = GlobalState();
	const latestApproval = (type) => getLatestApproval(pageData?.factoryApproval, type);

	const [basicDetailsModal, setBasicDetailsModal] = useState(false);
	const [basicDetailsModalType, setBasicDetailsModalType] = useState(EditCompanyDetailsModalTypes.edit);

	const [addressDetailsModal, setAddressDetailsModal] = useState(false);
	const [financeDetailsModal, setFinanceDetailsModal] = useState(false);
	const [editContactModal, setEditContactModal] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();
	const location = useLocation();
	const [selectedType, setSelectedType] = useState("");
	const [syncType, setSyncType] = useState("");
	const [syncConfirmOpen, setSyncConfirmOpen] = useState(false);
	const canSyncSection = (type) =>
		!!pageData?.is_same_as_company && !disableEdit && !latestApproval(type)?.approved;

	const applySyncedFactory = (factory) => {
		setPageData(factory);
		setFiles(factory?.factoryFiles || []);
		setContactPersons(factory?.factoryContactPersons || []);
		setComplianceCerts(factory?.factoryComplianceCertificates || []);
	};

	const handleSyncClick = (type) => {
		setSyncType(type);
		setSyncConfirmOpen(true);
	};

	const handleSyncFromCompany = async () => {
		if (!pageData?.id || !syncType) return;
		setLoadingOpen(true);
		try {
			const res = await axios.post(`/api/supplier/sync_factory_from_company`, {
				factory_id: pageData.id,
				type: syncType,
			});
			applySyncedFactory(res.data.result);
			setSyncConfirmOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `${SYNC_SECTION_LABELS[syncType] || syncType} synced from company`,
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error) || "Unable to sync from company",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
		setLoadingOpen(false);
	};

	const SyncFromCompanyButton = ({ type }) =>
		canSyncSection(type) ? (
			<Button variant="outlined" size="small" sx={{ mr: 1 }} onClick={() => handleSyncClick(type)}>
				Sync from company details
			</Button>
		) : null;

	const fetch = async (id) => {
		try {
			const factory = await axios.get(`/api/supplier/factory?id=${id}`);
			setPageData({ ...factory.data.result });
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	useEffect(() => {
		const id = searchParams.get(factoryUrlParamName);
		if (id && !pageData) {
			fetch(id);
		}
		// FactoryDetails stays mounted while other tabs are shown — only bounce when
		// the user is actually on the factory route without a selected factory.
		const onFactoryTab = location.pathname.split("/").includes(supplierDrawerElements.factory.key);
		if (!id && onFactoryTab) setTab(supplierDrawerElements.all_factories.key);
	}, [searchParams, location.pathname]);

	const [files, setFiles] = useState(
		pageData && pageData.factoryFiles
			? pageData.factoryFiles
			: [
					// { name: "comp_cert", url: "https://google.com", type: "Compliance_Certificate" },
					// { name: "pan_card_photo", url: "https://google.com", type: "Pan_Card_Photo" },
					// { name: "blank_check_photo", url: "https://google.com", type: "Blank_Check_photocopy" },
					// { name: "office_gst_certificate", url: "https://google.com", type: "Office_gst_certificate" },
			  ]
	);
	const [contactPersons, setContactPersons] = useState(
		pageData && pageData.factoryContactPersons ? pageData.factoryContactPersons : []
	);
	const [complianceCerts, setComplianceCerts] = useState(
		pageData && pageData.factoryComplianceCertificates ? pageData.factoryComplianceCertificates : []
	);

	const date = new Date();

	const updateCompanyDetails = async (body, setModalOpen) => {
		setLoadingOpen(true);
		try {
			await axios.put(`/api/supplier/update_factory/${pageData.id}`, body).then((res) => {
				setPageData({ ...pageData, ...body });
				setModalOpen(false);
				setSnackBarOpen(true);
				setLoadingOpen(false);
				handleEditFApprovalDb(selectedType, { ...pageData, ...body });
				setSnackBar({
					...snackBar,
					message: "Saved",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
		} catch (error) {
			setSnackBarOpen(true);
			setLoadingOpen(false);

			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const updateFilename = (fileData, nameCol, col2) => {
		const Newname = `${fileData[nameCol]?.split(" ").join("_")}_${col2 ? fileData[col2] : ""}_${new Date().valueOf()}`;
		return new File([fileData.file], Newname, {
			type: fileData.file.type,
			lastModified: fileData.file.lastModified,
		});
	};
	const handleFileUploadGCP = async (fileData, isMultiple, nameCol, col2) => {
		// type is factory/company
		const formData = new FormData();
		// for setting folderPath
		formData.append("id", pageData.id);
		if (isMultiple) {
			for (let i = 0; i < fileData.length; i++) {
				formData.append("files", updateFilename(fileData[i], nameCol, col2));
			}
			return await axios
				.post("/api/supplier/file_upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					return res.data;
				})
				.catch((err) => {
					return "Error in file Upload";
				});
		} else {
			formData.append("file", updateFilename(fileData, nameCol, col2));
			return await axios
				.post("/api/supplier/single_file_upload", formData, {
					headers: { "Content-Type": "multipart/form-data" },
				})
				.then((res) => {
					return res.data;
				})
				.catch((err) => {
					return "Error in file Upload";
				});
		}
	};
	const uploadFileDataToSQL = async (fileData) => {
		const res = await axios.post("/api/supplier/file_data_to_sql", fileData);
		return res?.data?.result;
	};
	const uploadComplianceCertToSQL = async (fileData) => {
		const res = await axios.post("/api/supplier/compliance_cert_to_sql", fileData);
		return res?.data?.result;
	};

	const handleFileAdd = async (fileData, isMultiple) => {
		try {
			if (fileData) {
				const fileLinkData = await handleFileUploadGCP(
					fileData,
					isMultiple,
					fileTableColumns.name.key,
					fileTableColumns.type.key
				);
				let newFiles = [];
				if (isMultiple) {
					const updatedFiles = fileData.map((row, i) => {
						let obj = { ...row, url: fileLinkData[i] };
						obj[foreignKey] = pageData.id;
						delete obj["file"];
						return obj;
					});
					newFiles = updatedFiles;
				} else {
					const file = { ...fileData, url: fileLinkData };
					file[foreignKey] = pageData.id;
					delete file["file"];
					newFiles = [file];
				}
				const data = await uploadFileDataToSQL(newFiles);
				// console.log(data);

				if (data) {
					let arr = [];
					if (isMultiple) arr = [[...files, ...data]];
					else arr = [...files, data?.[0]];
					setFiles(arr);
					return true;
				}
			}
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	const [selectedContact, setSelectedContact] = useState();

	const addCertificateFunction = async (fileData) => {
		try {
			if (fileData) {
				const fileLinkData = await handleFileUploadGCP(
					fileData,
					false,
					complianceCertColumns.compliance_certificate_issuer.key
				);
				let newFiles = [];
				const file = { ...fileData, url: fileLinkData };
				file[foreignKey] = pageData.id;
				delete file["file"];
				newFiles = [file];

				const data = await uploadComplianceCertToSQL(newFiles);
				// console.log(data);

				if (data?.[0]) {
					let arr = [...complianceCerts, data?.[0]];
					setComplianceCerts(arr);
					return true;
				} else throw new Error("Error in file Upload");
			}
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return false;
		}
	};
	const addContactPerson = async (data) => {
		try {
			if (data) {
				data[foreignKey] = pageData.id;
				if (selectedContact) {
					const result = await axios.put("/api/supplier/update_contact", data);
					if (result) {
						setContactPersons(
							contactPersons.map((row) => {
								if (data.id === row.id) return data;
								else return row;
							})
						);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: "Updated",
							severity: "success",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
						return true;
					}
				} else {
					const result = await axios.post("/api/supplier/create_contact", data);
					if (result) {
						setContactPersons([...contactPersons, result.data.result]);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: "Created",
							severity: "success",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
						return true;
					}
				}
			}
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrMsgFromError(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return false;
		}
	};
	const logeduser = loginUser.role?.FINANCE_VIEWER ? true : false;
	const handleContactClick = (contact) => {
		setSelectedContact(contact);
		setEditContactModal(true);
	};
	const handleRejectedFactoryButton = (type) => {
		if (typeof handleReject === "function") handleReject(type);
	};
	const handleFileDeleteclick = async (row) => {
		if (!disableEdit) {
			setLoadingOpen(true);
			try {
				await axios.delete(`/api/supplier/delete_supplier_file/${row.id}`).then((res) => {
					setFiles(files.filter((cert) => row.id !== cert.id));
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Deleted",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					setLoadingOpen(false);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Unable To Delete",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		}
	};
	if (pageData)
		return (
			<Stack width="100%" spacing={2.5}>
				{!hidePageHeader ? (
				<SupplierPageHeader
					title={pageData?.name || "Factory"}
					subtitle={
						<Breadcrumbs
							aria-label="breadcrumb"
							sx={{
								"& .MuiBreadcrumbs-separator": { mx: 0.75, color: supplierUi.textMuted },
							}}>
							<Typography variant="body2" color={supplierUi.textMuted}>
								Supplier
							</Typography>
							<MuiLink
								component="button"
								underline="hover"
								variant="body2"
								sx={{ color: supplierUi.textSecondary, border: 0, background: "none", cursor: "pointer", p: 0 }}
								onClick={() => setTab(supplierDrawerElements.company_info.key)}>
								{companyData?.company_name}
							</MuiLink>
							<Typography variant="body2" color={supplierUi.textPrimary} fontWeight={500}>
								Factory
							</Typography>
						</Breadcrumbs>
					}
					actions={
						pageData?.is_same_as_company ? (
							<Chip
								label="Same as company"
								size="small"
								variant="outlined"
								sx={{
									borderColor: supplierUi.borderStrong,
									color: supplierUi.textSecondary,
									fontWeight: 600,
									height: 26,
								}}
							/>
						) : pageData?.factory_code ? (
							<Chip
								label={pageData.factory_code}
								size="small"
								sx={{
									bgcolor: "#F2F4F7",
									color: supplierUi.textPrimary,
									fontWeight: 600,
									height: 26,
								}}
							/>
						) : null
					}
				/>
				) : (
					<Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
						{pageData?.factory_code ? (
							<Chip
								label={pageData.factory_code}
								size="small"
								sx={{ bgcolor: "#F2F4F7", color: supplierUi.textPrimary, fontWeight: 600, height: 26 }}
							/>
						) : null}
						{pageData?.is_same_as_company ? (
							<Chip
								label="Same as company"
								size="small"
								variant="outlined"
								sx={{
									borderColor: supplierUi.borderStrong,
									color: supplierUi.textSecondary,
									fontWeight: 600,
									height: 26,
								}}
							/>
						) : null}
					</Stack>
				)}

				<SupplierSection
					title="Basic Details"
					actions={
						<Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
							<SyncFromCompanyButton type="basic_details" />
							<StatusButtons
								handleReject={() => handleRejectedFactoryButton("basic_details")}
								handleApproval={() => updateSupplierStore("basic_details")}
								handleUnapprove={() => handleUnapprove && handleUnapprove("basic_details")}
								disableEdit={disableEdit}
								handleEdit={() => {
									setBasicDetailsModal(true);
									setSelectedType("basic_details");
								}}
								otherAccess={!logeduser}
								editButton={true}
								buttonName="Edit"
								approved={latestApproval("basic_details")?.approved}
								remark={latestApproval("basic_details")?.remark}
								action={latestApproval("basic_details")?.action}
							/>
						</Stack>
					}>
					<DisplayInfo labelData={factoryBasicDetailColumns} values={pageData} />
				</SupplierSection>

				<SupplierSection
					title="Address Details"
					actions={
						<Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
							<SyncFromCompanyButton type="address_details" />
							<StatusButtons
								handleReject={() => handleRejectedFactoryButton("address_details")}
								handleApproval={() => updateSupplierStore("address_details")}
								handleUnapprove={() => handleUnapprove && handleUnapprove("address_details")}
								disableEdit={disableEdit}
								handleEdit={() => {
									setAddressDetailsModal(true);
									setSelectedType("address_details");
								}}
								editButton={true}
								otherAccess={!logeduser}
								buttonName="Edit"
								approved={latestApproval("address_details")?.approved}
								remark={latestApproval("address_details")?.remark}
								action={latestApproval("address_details")?.action}
							/>
						</Stack>
					}>
					<DisplayAddressInfo labelData={factoryAddressDetailColumns} values={pageData} />
				</SupplierSection>

				<SupplierSection
					title="Files"
					actions={
						<Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
							<SyncFromCompanyButton type="files" />
							<StatusButtons
								handleReject={() => handleRejectedFactoryButton("files")}
								handleApproval={() => updateSupplierStore("files")}
								handleUnapprove={() => handleUnapprove && handleUnapprove("files")}
								disableEdit={disableEdit}
								handleEdit={() => {}}
								editButton={false}
								buttonName="Edit"
								otherAccess={!logeduser}
								approved={latestApproval("files")?.approved}
								remark={latestApproval("files")?.remark}
								action={latestApproval("files")?.action}
							/>
						</Stack>
					}>
					<Stack direction={{ xs: "column", md: "row" }} spacing={2.5} alignItems="stretch">
						<Box flexGrow={1} minWidth={0} sx={{ maxHeight: 420, overflowY: "auto", overflowX: "hidden" }}>
							<DisplayTable
								rows={files}
								columns={fileTableColumns}
								downloadUrlColumn="url"
								deleteFun={handleFileDeleteclick}
								disableEdit={disableEdit}
								generateFileDownloadUrl={getSupplierFileSignedUrl}
							/>
						</Box>
						{!disableEdit && (
							<Box width={{ xs: "100%", md: 320 }} flexShrink={0}>
								<AddFiles
									fullWidth
									files={files}
									setFiles={setFiles}
									submitFunction={handleFileAdd}
									disableAdd={disableEdit || latestApproval("files")?.approved}
								/>
							</Box>
						)}
					</Stack>
				</SupplierSection>

				<SupplierSection
					title="Compliance Certificates"
					actions={
						<Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
							<SyncFromCompanyButton type="compliance_certificates" />
							<StatusButtons
								handleReject={() => handleRejectedFactoryButton("compliance_certificates")}
								handleApproval={() => updateSupplierStore("compliance_certificates")}
								handleUnapprove={() => handleUnapprove && handleUnapprove("compliance_certificates")}
								disableEdit={disableEdit}
								handleEdit={() => {}}
								editButton={false}
								otherAccess={!logeduser}
								buttonName="Edit"
								approved={latestApproval("compliance_certificates")?.approved}
								remark={latestApproval("compliance_certificates")?.remark}
								action={latestApproval("compliance_certificates")?.action}
							/>
						</Stack>
					}>
					<ComplianceCertificates
						complianceCerts={complianceCerts}
						setComplianceCerts={setComplianceCerts}
						addCertificateFunction={addCertificateFunction}
						disableAdd={disableEdit || latestApproval("compliance_certificates")?.approved}
						disableEdit={disableEdit}
					/>
				</SupplierSection>

				<SupplierSection
					title="Contact Details"
					actions={
						<Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
							<SyncFromCompanyButton type="contact_details" />
							<StatusButtons
								handleReject={() => handleRejectedFactoryButton("contact_details")}
								handleApproval={() => updateSupplierStore("contact_details")}
								handleUnapprove={() => handleUnapprove && handleUnapprove("contact_details")}
								disableEdit={disableEdit}
								handleEdit={() => {
									setEditContactModal(true);
									setSelectedType("contact_details");
								}}
								editButton={true}
								otherAccess={!logeduser}
								buttonName="Add"
								approved={latestApproval("contact_details")?.approved}
								remark={latestApproval("contact_details")?.remark}
								action={latestApproval("contact_details")?.action}
							/>
						</Stack>
					}>
					<DisplayTable
						columns={contactPersonColumns}
						rows={contactPersons}
						disableEdit={
							disableEdit || latestApproval("contact_details")?.approved ? true : false
						}
						onRowClick={
							disableEdit || latestApproval("contact_details")?.approved ? () => {} : handleContactClick
						}
					/>
				</SupplierSection>

				<Dialog open={syncConfirmOpen} onClose={() => setSyncConfirmOpen(false)}>
					<DialogTitle>Sync from company details</DialogTitle>
					<DialogContent>
						{`Copy company ${SYNC_SECTION_LABELS[syncType] || syncType} into this factory? Existing factory data for this section will be replaced.`}
					</DialogContent>
					<DialogActions>
						<Button onClick={() => setSyncConfirmOpen(false)}>Cancel</Button>
						<Button variant="contained" onClick={handleSyncFromCompany}>
							Sync
						</Button>
					</DialogActions>
				</Dialog>

				<EditFactoryDetails
					modalOpen={basicDetailsModal}
					setModalOpen={setBasicDetailsModal}
					basicDetails={pageData}
					setBasicDetails={setPageData}
					type={EditCompanyDetailsModalTypes.edit}
					submitFunction={updateCompanyDetails}
				/>
				<EditAddressDetails
					modalOpen={addressDetailsModal}
					setModalOpen={setAddressDetailsModal}
					addressData={pageData}
					setAddressData={setPageData}
					submitFunction={updateCompanyDetails}
					companyData={companyData}
				/>
				<EditContactPersons
					modalOpen={editContactModal}
					setModalOpen={setEditContactModal}
					selected={selectedContact}
					setSelected={setSelectedContact}
					submitFunction={addContactPerson}
					key={editContactModal}
				/>
			</Stack>
		);
};

export default FactoryDetails;
